var collapsible_list_pair_rtlignore_default = {
  "container": "RGQZn",
  "title": "sMLnb",
  "viewerContainer": "VSydu",
  "titleContainer": "_1CILS",
  "content": "_91G7A",
  "expandIcon": "_4wZlF",
  "dndIcon": "yITjU",
  "RTL": "GlQR4",
  "LTR": "n-8ru",
  "itemContainer": "hQTX0",
  "itemContainerViewer": "tBjNx",
  "mouseDown": "ZtWQK",
  "innerEditor": "cvJ4P",
  "item": "tgq1R",
  "floatingAddPluginMenuWrapper": "I6-Jt"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
